module.exports = __webpack_public_path__ + "static/media/upload-evidence-img.80bcd2ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-it-works-assessment-signature/upload-evidence-img.png
// module id = 381
// module chunks = 0